export function useFieldFlatpickr(): Promise<any> {
  return import('../module/field-flatpickr');
}
